import { getLineGraphFormat, getRandomUniqueColor } from "./format-utils";
import {
  CONSTANTS,
  GRAPH_TYPES,
  REPORT_TYPES,
  VERTICALS,
} from "../../../constants/app-constant";
import { groupBy } from "../../../utility/common-methods";
import {
  formatDataByTrend,
  formatDataByJournalist,
  formatDataByEdition,
} from "./format-data-by-trend";
import { formatDataByRanking } from "./format-data-by-ranking";
import { formatDataByTonality } from "./format-data-by-tonality";
const { AREA } = GRAPH_TYPES;
const {
  REPORTS: { TYPES },
} = CONSTANTS;
export const formatedDataByJournalist = (
  d = [],
  graph_type,
  isLineGraph,
  type,
  report_type,
  isEmbededWidget = false
) => {
  try {
    if (
      report_type === REPORT_TYPES.JournalistNOATrend ||
      report_type === REPORT_TYPES.JournalistMAVTrend ||
      report_type === REPORT_TYPES.JournalistWCTrend ||
      report_type === REPORT_TYPES.JournalistCCMTrend
    ) {
      return formatDataByTrend(d, graph_type, isLineGraph, type, report_type);
    }
    if (report_type === REPORT_TYPES.JournalistAnalysisPrint) {
      return formatDataByJournalist(
        d,
        graph_type,
        isLineGraph,
        type,
        report_type
      );
    }
    if (report_type === REPORT_TYPES.EditionWiseNOATrend) {
      return formatDataByEdition(d, graph_type, isLineGraph, type, report_type);
    }
    if (
      (report_type === REPORT_TYPES.JournalistTonalityNOARanking) |
      (report_type === REPORT_TYPES.JournalistTonalityMAVRanking) ||
      report_type === REPORT_TYPES.JournalistTonalityCCMRanking ||
      report_type === REPORT_TYPES.JournalistTonalityWCRanking
    ) {
      return formatDataByTonality(
        d,
        graph_type,
        isLineGraph,
        type,
        report_type
      );
    }
    //return formatDataByRanking(d, graph_type, isLineGraph, type, report_type);
    const reportType = TYPES.filter((t) => t.id == report_type)[0];
    const {
      graphDataType: { print, online },
      entityKey,
      sourceKey,
      sourceKeyWithPublications,
      countKey,
    } = reportType;
    const rType = type === VERTICALS.V_PRINT ? print : online;
    let dataByReportType = d[rType] && d[rType].returnData;
    dataByReportType = dataByReportType.map((dataObj) => {
      const publicationList = dataObj.publications;
      let updated_source_name = dataObj.source_name;
      if (publicationList && publicationList.length) {
        let publicationNameStr = "[";
        for (let pbName of publicationList) {
          publicationNameStr += pbName + ", ";
        }
        publicationNameStr =
          publicationNameStr.substring(0, publicationNameStr.length - 2) + "]";
        updated_source_name += publicationNameStr;
      }
      return {
        ...dataObj,
        updated_source_name,
      };
    });
    const groupedDataByEntity = groupBy(dataByReportType, entityKey) || {};
    const groupedDataByJournalist =
      groupBy(
        dataByReportType,
        isEmbededWidget ? sourceKeyWithPublications : sourceKey
      ) || {};
    const entityNames = Object.keys(groupedDataByEntity);
    const journalistNames = Object.keys(groupedDataByJournalist);
    const graphColors = getRandomUniqueColor(journalistNames.length);
    const labels = isLineGraph
      ? getLineGraphFormat(journalistNames, true)
      : journalistNames;
    const datasets = entityNames.map((eName, index) => {
      const eObjArray = groupedDataByEntity[eName];
      let data = journalistNames.map((journalist) => {
        const eForJournalist = eObjArray.filter((e) =>
          isEmbededWidget
            ? e.updated_source_name === journalist
            : e.source_name === journalist
        )[0];
        return (eForJournalist && eForJournalist[countKey]) || 0;
      });
      data = isLineGraph ? getLineGraphFormat(data) : data;
      return {
        data,
        label: entityNames[index],
        backgroundColor:
          graph_type === AREA && typeof window.Color === "function"
            ? window.Color(graphColors[index]).alpha(0.5).rgbString()
            : graphColors[index],
        borderColor: graphColors[index],
        borderWidth: 1,
        fill: graph_type === AREA ? "start" : false,
        lineTension: 0,
      };
    });
    const sumArray = [];
    datasets.forEach((ele) => {
      ele.data.forEach((val, ind) => {
        sumArray[ind] = {
          index: ind,
          total:
            (sumArray[ind] && sumArray[ind].total ? sumArray[ind].total : 0) +
            +val,
        };
      });
    });
    sumArray.sort((eleA, eleB) => eleB.total - eleA.total);
    datasets.map((ele) => {
      const newData = [];
      sumArray.forEach((val) => newData.push(ele.data[val.index]));
      ele.data = newData;
      return ele;
    });
    const sortedLabels = [];
    sumArray.forEach((val) => sortedLabels.push(labels[val.index]));
    return {
      datasets,
      labels: sortedLabels,
    };
  } catch (e) {
    return {
      datasets: [],
      labels: [],
    };
  }
  //     const datasets = entityNames.map((eName, index) => {
  //       const eObjArray = groupedDataByEntity[eName];
  //       let data = journalistNames.map((journalist) => {
  //         const eForJournalist = eObjArray.filter(
  //           (e) => e.source_name === journalist
  //         )[0];
  //         return (eForJournalist && eForJournalist[countKey]) || 0;
  //       });
  //       data = isLineGraph ? getLineGraphFormat(data) : data;
  //       return {
  //         data,
  //         label: entityNames[index],
  //         backgroundColor:
  //           graph_type === AREA && typeof window.Color === "function"
  //             ? window.Color(graphColors[index]).alpha(0.5).rgbString()
  //             : graphColors[index],
  //         borderColor: graphColors[index],
  //         borderWidth: 1,
  //         fill: graph_type === AREA ? "start" : false,
  //         lineTension: 0,
  //       };
  //     });
  //     return {
  //       datasets,
  //       labels,
  //     };
  //   } catch (e) {
  //     return {
  //       datasets: [],
  //       labels: [],
  //     };
  //   }
};
